import React, {useState} from 'react';
import "./MFeatureGrid.css";

import qrcode from '../../../Assets/QR_Code.png'
import listing from '../../../Assets/Listing-example.png'
import cloud from '../../../Assets/cloud_storage.png'
import smartPlan from '../../../Assets/Digital-Interactions-Page-Media.png'

const MFeatureGrid = () => {

    const getWidth = (type) => {
        const win_width = window.innerWidth;
        let width = 0;
        switch (type) {
            case "qr":
                width = win_width*0.6;
                break;
            case "smart":
                width = win_width*0.86;
                break;
            case "listing":
                width=win_width*0.8;
                break;
            case "cloud":
                width=win_width*0.8;
                break;
            default:
                width=win_width*0.8;
        }
        return width;
    }

    const getHeight = (type) => {
        const win_height = window.innerHeight;
        const win_width = window.innerWidth;
        let height = 0;
        switch (type) {
            case "qr":
                height = win_width*0.6;
                break;
            case "smart":
                height = win_width*0.86;
                break;
            case "listing":
                height=win_width*0.8;
                break;
            case "cloud":
                height=win_width*0.8;
                break;
            default:
                height=win_width*0.8;
        }
        return height;
    }

  return(
    <div className="mfeature-grid-outter">
        <div className="mfeature-grid-text">
            <p className='mteam-collab-title'>
            Team Collaboration
            </p>
            <p className='mteam-collab-text'>
            In Every Way Possible.
            </p>
        </div>
        <div className="mfeature-grid-inner">
            <div className="mgrid-item">
                <div className="mschedule-feature">
                    <img 
                    className="mfeature1" 
                    src={qrcode} 
                    width={getWidth("qr")} 
                    height={getHeight("qr")}
                    alt="qr code virtual tour"/>
                </div>
                <div className="mfeature-desc">
                    <p className="mclient-schedule-title">Generate QR Codes</p>
                    <p className="mclient-schedule-p">With custom-generated QR codes for your open houses, engaging buyers has never been easier. Transform mundane tours into memorable experiences, allowing buyers to relive your listing long after they've left. </p>
                </div>
            </div>
        </div>
        <div className="mfeature-grid-inner">
            <div className="mgrid-item">
                <div className="mschedule-feature">
                {/* <iframe 
                    className='mfeature1'
                    src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapIt_Demo_Video.mp4"
                    frameBorder="0"
                    allow="accelerometer"
                    allowFullScreen
                /> */}
                <img 
                className="mfeature1" 
                src={smartPlan} 
                width={getWidth("smart")} 
                height={getHeight("smart")}
                alt="interactive floor plan"/>
                </div>
                <div className="mfeature-desc">
                    <p className="mclient-schedule-title">Blend Your Photos and Plans</p>
                    <p className="mclient-schedule-p">Generate intelligent floorplans enhanced with images and videos to present to prospective buyers.</p>
                </div>
            </div>
        </div>
        <div className="mfeature-grid-inner">
            <div className="mgrid-item">
                <div className="mschedule-feature">
                    {/* <iframe 
                        className='mfeature1'
                        src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapIt_Demo_Video.mp4"
                        frameBorder="0"
                        allow="accelerometer"
                        allowFullScreen
                    /> */}
                    <img 
                    src={listing} 
                    width={getWidth("listing")} 
                    height={getHeight("listing")}
                    alt="real estate listing"/>
                </div>
                <div className="mfeature-desc">
                    <p className="mclient-schedule-title">Help Buyers Recall Your Listing</p>
                    <p className="mclient-schedule-p">Say goodbye to forgettable listings and hello to unforgettable impressions. 
                    Make your property the talk of the town with our innovative solution. Stand out. Be remembered. Experience the future of home tours today.</p>
                    {/* <p className="client-schedule-p">Offer a comprehensive package of documents, videos, images, and financial data to provide your investment clients with all the information they need.</p> */}
                </div>
            </div>
        </div>
        <div className="mfeature-grid-inner">
            <div className="mgrid-item2">
                <div className="mschedule-feature">
                {/* <iframe 
                    className='mfeature1'
                    src="https://mapit-asset-bucket.s3.us-west-2.amazonaws.com/MapIt_Demo_Video.mp4"
                    frameBorder="0"
                    allow="accelerometer"
                    allowFullScreen
                /> */}
                <img 
                src={cloud} 
                width={getWidth("cloud")} 
                height={getHeight("cloud")}
                alt="storage for real estate plans, photos and videos"/>
                </div>
                <div className="mfeature-desc">
                    <p className="mclient-schedule-title">Unlimited Cloud Storage</p>
                    <p className="mclient-schedule-p">Efficiently organize and securely store your smart floor plans, making them easily accessible from any device.</p>
                </div>
            </div>
        </div>
    </div>
  );
}

export default MFeatureGrid;